import { useTranslation } from "react-i18next";

import type { CalibrationDecisionItem } from "@/api/calibration";

/**
 * Os itens "Precisa de decisão" da aprovação, à parte e sem horas (22/10/2026).
 *
 * Eles estão no escopo, mas o caminho ainda não foi escolhido. Contá-los nas
 * horas punha no número um item que talvez não seja ativado (na AL5 eram 262
 * de 316); escondê-los deixava a pessoa sem saber que o número vai crescer
 * quando o Functional decidir. Por isso a lista aparece, fechada, com a conta
 * ao lado.
 */
export function DecisionItems({ items }: { items: CalibrationDecisionItem[] }) {
  const { t } = useTranslation();
  if (items.length === 0) return null;

  return (
    <details
      data-testid="calibration-decision-items"
      className="rounded-md border border-[#e8ebf0] bg-[#f8f9fb] px-4 py-3 text-sm"
    >
      <summary className="cursor-pointer font-medium">
        {t("Awaiting a decision ({{count}}): outside the hours until the Functional decides", {
          count: items.length,
        })}
      </summary>
      <ul className="mt-2 max-h-64 divide-y overflow-y-auto">
        {items.map((item) => (
          <li key={item.code} className="flex items-center gap-3 py-1.5">
            <code className="w-12 shrink-0 text-xs text-muted-foreground">{item.code}</code>
            <span className="min-w-0 flex-1 truncate">{item.name ?? item.code}</span>
            <span className="shrink-0 text-xs text-muted-foreground">{item.lob}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
